document.addEventListener("DOMContentLoaded", () => {
    new window.Vue({
        el: "#search-results-component",
        data: function () {
            return {
                query: "",
                searchResults: [],
                pages: [],
                noResults: false,
            };
        },
        mounted() {
            const queryParam = new URLSearchParams(window.location.search).get("q");
            this.search(queryParam, 1);
            this.query = queryParam;
        },
        methods: {
            search: async function (q, start = 1) {
                try {
                    let url;
                    if (window.location.hostname === "localhost") {
                        // Use static JSON file on localhost
                        url = "http://localhost:8082/search.json";
                    } else {
                        // Google Custom Search
                        url =
                            "https://www.googleapis.com/customsearch/v1?key=" +
                            googleSearchID +
                            "&cx=" +
                            googleSearchCX +
                            "&q=" +
                            encodeURIComponent(q) +
                            "&start=" +
                            start +
                            "&prettyPrint=false";
                    }

                    const response = await fetch(url);
                    const json = await response.json();

                    const pages = [];
                    let totalResults = 0;

                    if (window.location.hostname === "localhost") {
                        // Filter mock results for localhost
                        const filteredResults = json.items.filter(
                            (item) => item.title.toLowerCase().includes(q.toLowerCase()), // optional, filter by query
                        );
                        totalResults = filteredResults.length;

                        // Pagination (10 per page)
                        const startIndex = (start - 1) * 10;
                        const paginatedResults = filteredResults.slice(startIndex, startIndex + 10);

                        this.searchResults = paginatedResults;

                        // Pages array
                        const endPage = Math.min(10, Math.ceil(totalResults / 10));
                        for (let i = 1; i <= endPage; i++) {
                            pages.push({
                                id: i,
                                activeClass: i === start ? "active" : "",
                                url: "?q=" + q + "&start=" + i,
                            });
                        }
                    } else {
                        // Google API
                        const req = json.queries.request[0];
                        const currentPage = Math.ceil(req.startIndex / 10);
                        const endPage = Math.min(10, Math.ceil(req.totalResults / 10));

                        for (let i = 1; i <= endPage; i++) {
                            pages.push({
                                id: i,
                                activeClass: i === currentPage ? "active" : "",
                                url: "?q=" + q + "&start=" + ((i - 1) * 10 + 1),
                            });
                        }

                        const currentLanguagePrefix = window.location.pathname.substring(0, 4);
                        this.searchResults = json.items.filter((item) => item.link.includes(currentLanguagePrefix));

                        totalResults = this.searchResults.length;
                    }

                    this.pages = pages;
                    this.noResults = this.searchResults.length === 0;

                    this.trackSearch(q, start, totalResults);
                } catch (error) {
                    console.error("Search failed:", error);
                    this.searchResults = [];
                    this.pages = [];
                    this.noResults = true;

                    this.trackSearch(q, start, 0);
                }
            },

            trackSearch: function (q, start, resultsCount) {
                if (start !== 1 && start !== "1") return;

                const tryTrack = () => {
                    if (
                        window.AdobeTracking &&
                        typeof window.AdobeTracking.trackInternalSearchCompleted === "function"
                    ) {
                        window.AdobeTracking.trackInternalSearchCompleted({
                            searchKeyword: q,
                            numberOfSearchResults: resultsCount,
                            interactionIdentifier: "search bar",
                        });
                    } else {
                        setTimeout(tryTrack, 100);
                    }
                };

                tryTrack();
            },
            pageLink: function (url, event, clickedIndex = 0, runSearch = false) {
                const clickedResult = this.searchResults[clickedIndex];

                if (clickedResult) {
                    const eventData = {
                        searchKeyword: this.query,
                        searchResultIndex: clickedIndex + 1,
                        clickedText: clickedResult.title || clickedResult.htmlTitle,
                        clickedURL: clickedResult.link,
                        numberOfSearchResults: this.searchResults.length,
                    };

                    window.AdobeTracking.trackSearchClickThrough(eventData);
                }

                if (runSearch) {
                    const start = parseInt(url.split("&start=")[1] || "1", 10);
                    this.search(this.query, start);
                }

                window.scrollTo(0, 0);
            },
        },
    });
});
